package com.bikompanion.data.rating

import kotlinx.serialization.Serializable

@Serializable
internal data class PendingVotes(
    val votes: List<PendingVote>,
)
